export default {
  drivers: (state) => state.drivers
}